import React, { useEffect } from "react";

/**
 * CameraStream - Stream setup & video element component
 * Handles the video element that displays the camera stream
 */
const CameraStream = ({
	videoRef,
	stream,
	facingMode,
	hasPermission,
	isInitializing,
	onUserInteraction,
}) => {
	// Apply transform for front-facing camera
	useEffect(() => {
		if (videoRef.current && stream) {
			videoRef.current.style.transform =
				facingMode === "user" ? "scaleX(-1)" : "none";
		}
	}, [videoRef, stream, facingMode]);

	// Ensure video plays when stream is set
	useEffect(() => {
		if (videoRef.current && stream && hasPermission && !isInitializing) {
			const video = videoRef.current;
			const streamObj = stream;

			// Ensure stream is attached to video
			if (video.srcObject !== streamObj) {
				console.log("🔗 Attaching stream to video element via useEffect");
				video.srcObject = streamObj;
			}

			// Ensure video is set up for autoplay
			video.muted = true;
			video.playsInline = true;
			video.autoplay = true;

			// Try to play if paused
			if (video.paused && streamObj) {
				const videoTracks = streamObj.getVideoTracks();
				if (videoTracks.length > 0 && videoTracks[0].readyState === "live") {
					video
						.play()
						.then(() => {
							console.log("✅ Video started playing");
						})
						.catch((err) => {
							console.warn("⚠️ Video play error:", err);
						});
				}
			}
		}
	}, [videoRef, stream, hasPermission, isInitializing]);

	return (
		<video
			ref={videoRef}
			autoPlay
			playsInline
			muted
			className="absolute inset-0 h-full w-full object-cover"
			onClick={onUserInteraction}
			onTouchStart={onUserInteraction}
		/>
	);
};

export default CameraStream;
